export default "__VITE_ASSET__Bdc9V644__"